/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum BackupOptionsTarget {
    SelectedItems = 'selectedItems',
    ExcludedItems = 'excludedItems',
}